angular.module('mercury.modules.reports.discounts')
.factory('PosSurcharges', ["$resource", "settings", function($resource, settings) {
  var Surcharges = $resource(settings.mercHost + '/pos/surcharges');

  function get(start, end) {
    return Surcharges.query({start: start, end: end}).$promise;
  }

  return {
    get: get
  };
}]);
